// extracted by mini-css-extract-plugin
export default {"signInInvitation":"SignInInvitation_signInInvitation__gswnL","enterScreen":"SignInInvitation_enterScreen__AtAgs"};